import { Logo } from "./Logo";
import { WHATSAPP_URL, WHATSAPP_DISPLAY } from "../i18n/translations";

export const Footer = ({ t }) => {
  const scrollTo = (id) => (e) => {
    e.preventDefault();
    if (window.__lenis) window.__lenis.scrollTo(id, { offset: -72, duration: 1.4 });
    else document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="main-footer" className="border-t border-white/10 bg-[#080B10] px-5 py-14 sm:px-8">
      <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-3">
        <div>
          <Logo />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">{t.footer.tagline}</p>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.24em] text-amber-400">{t.footer.navTitle}</h4>
          <div className="mt-4 flex flex-col gap-2.5">
            <a href="#services" data-testid="footer-link-services" onClick={scrollTo("#services")} className="text-sm text-slate-400 transition-colors hover:text-white">{t.nav.services}</a>
            <a href="#offices" data-testid="footer-link-offices" onClick={scrollTo("#offices")} className="text-sm text-slate-400 transition-colors hover:text-white">{t.nav.offices}</a>
            <a href="#contact" data-testid="footer-link-contact" onClick={scrollTo("#contact")} className="text-sm text-slate-400 transition-colors hover:text-white">{t.nav.contact}</a>
            <a href="/admin/login" data-testid="footer-link-admin" className="text-sm text-slate-400 transition-colors hover:text-white">Panel de control</a>
          </div>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.24em] text-amber-400">{t.footer.contactTitle}</h4>
          <div className="mt-4 flex flex-col gap-2.5 text-sm text-slate-400">
            <span data-testid="footer-office-caracas">Centro Comercial Concresa, Piso 3, Caracas, Venezuela</span>
            <span data-testid="footer-office-croton">17 Bari Mnr, Croton-on-Hudson, NY 10520, USA</span>
            <a
              data-testid="footer-whatsapp-link"
              href={`${WHATSAPP_URL}?text=${encodeURIComponent(t.whatsapp_prefill)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-amber-300 transition-colors hover:text-amber-200"
            >
              WhatsApp {WHATSAPP_DISPLAY}
            </a>
            <a data-testid="footer-email-link" href="mailto:Sagaslogistic@gmail.com" className="transition-colors hover:text-white">
              Sagaslogistic@gmail.com
            </a>
          </div>
        </div>
      </div>
      <div className="mx-auto mt-12 max-w-7xl border-t border-white/10 pt-6 text-xs text-slate-500">{t.footer.rights}</div>
    </footer>
  );
};
